export const ActionTypes = {
  LOADING: "GET_SHARED_DECISIONS_LOADING",
  ERROR: "GET_SHARED_DECISIONS_ERROR",
  SUCCESS: "GET_SHARED_DECISIONS_SUCCESS"
};
